<template>
    <CNCOperationDash></CNCOperationDash>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const CNCOperationDash = defineAsyncComponent(() =>
    import("../../components/CNC/CNCOperationDash/CNCOperationDash.vue")
);

export default {
    name: "CNC_Ope_Dash", //The name you are in should not equal the name of the component you are importing.
    components: { CNCOperationDash, AuthLayout },
};
</script>

<style scoped></style>
